export default __webpack_public_path__ + "static/img-cs-zappi-timeline-ae9e12fb2aa7974d41b8df08eb69b7e5.webp";